import { getPatternStyles, patternFns, __spreadValues } from '../helpers.mjs';
import { css } from '../css/index.mjs';

const levelCenterConfig = {
transform(props) {
  return __spreadValues({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gridArea: "center"
  }, props);
}}

export const getLevelCenterStyle = (styles = {}) => {
  const _styles = getPatternStyles(levelCenterConfig, styles)
  return levelCenterConfig.transform(_styles, patternFns)
}

export const levelCenter = (styles) => css(getLevelCenterStyle(styles))
levelCenter.raw = getLevelCenterStyle